import socketIoClient from 'socket.io-client';

// This helper is necessary to make Cypress working by injecting
// a mock socket.io client on the window

const win = window;
export default win.io !== undefined ? win.io : socketIoClient;